<div class="w-full h-full relative">
  <div class="flex flex-row justify-end items-center w-full absolute">
    <sbnb-close [border]="true" (click)="closeModal()"></sbnb-close>
  </div>

  <div id="wizard-content">
    <div class="flex flex-col items-center justify-center">
      <div class="grid sbnbDesktop:grid-cols-2">
        <div class="flex flex-col items-center justify-center max-w-4xl mx-auto p-8">
          <div class="w-full flex flex-col gap-6">
            <h2 class="text-2xl font-semibold m-0">We couldn't activate dynamic pricing...</h2>

            <div class="flex flex-col gap-2">
              <p class="text-night text-base m-0">
                Something's blocking setup for this property. This might be because:
              </p>
              <ul class="list-disc list-inside m-0 pl-2">
                <li class="text-night text-base">Some property details may need adjusting.</li>
                <li class="text-night text-base">We don't have enough market data for this location.</li>
                <li class="text-night text-base">This region isn't supported due to legal or data restrictions.</li>
              </ul>
              <p class="text-night text-base m-0">
                If you think this is a mistake or need help, please contact us.
              </p>
            </div>

            <div class="grid gap-6 grid-cols-[1fr_1fr]">
              <sbnb-button
                [type]="'secondary'"
                [fullWidth]="true"
                [label]="'Go Back'"
                (click)="closeModal()"></sbnb-button>
              <sbnb-button
                [type]="'primary'"
                [fullWidth]="true"
                [loading]="loading"
                [label]="'Contact support'"
                (click)="closeModal('contact-support')"></sbnb-button>
            </div>
          </div>
        </div>
        <div class="flex flex-col items-center justify-center">
          <img src="/assets/images/dynamic-pricing-flow/error.png" alt="There was an error enabling dynamic pricing for this property" width="330" />
        </div>
      </div>
    </div>
  </div>
</div>
